import { getApiVersion } from 'app/branches/selectors';
import type { BranchesSlice } from 'app/branches/types';
import { connect } from 'react-redux';
import ApiVersionWrapper, { type ApiVersionWrapperStateProps } from './api-version-wrapper';

export function mapStateToProps(state: BranchesSlice): ApiVersionWrapperStateProps {
  return {
    apiVersion: getApiVersion(state)
  };
}

export default connect(mapStateToProps)(ApiVersionWrapper);
